import { render, staticRenderFns } from "./TasksHistoryModal.vue?vue&type=template&id=4d1b0414"
import script from "./TasksHistoryModal.vue?vue&type=script&lang=js"
export * from "./TasksHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports